module.exports = __webpack_public_path__ + "static/media/ODS06.0c5a178b.jpg";